// extracted by mini-css-extract-plugin
export default {"kitoBalloon":"styles_kitoBalloon__jjUBu"};